"use client";
import React from "react";
import Layout from "./Layout";
import Rail from "./Rail";
import ShopRowCard from "components/home/Card/ShopRowCard";
import type { SlotDiscount } from "services/campaignPackage/formatter";
import { get } from "utils/lodash";
import { useT, useI18n } from "providers/I18nProvider";
import useRotatingTagline from "hooks/useRotatingTagline";

/**
 * Section "Săn giờ đẹp mỗi ngày" — shop có khuyến mãi theo khung giờ.
 * Listing LM2 chỉ trả shop; % giảm + khung giờ nằm ở CampaignPackage type=slot.
 * Component KHÔNG tự fetch: `dealMap` (shopId → deal) do app/[locale]/page.tsx lấy sẵn ở server
 * (services/campaignPackage/server.ts fetchSlotDealMap) → HTML có sẵn dải này.
 * Shop không có gói slot còn hiệu lực sẽ bị ẩn (không bịa số).
 */
const SectionSlotDiscount: React.FC<{
  title?: string;
  description?: string;
  data?: any[];
  dealMap?: Record<string, SlotDiscount>;
}> = ({ title, description, data, dealMap = {} }) => {
  const t = useT();
  const { locale } = useI18n();
  // Câu giới thiệu tự đổi mỗi 2 phút (4 biến thể trong file dịch)
  const rotatingDesc = useRotatingTagline("home.slotDiscountDesc", description);

  const shops = (data || [])
    .filter((s) => !!get(s, "slug"))
    .map((s) => ({ shop: s, deal: dealMap[get(s, "id")] as SlotDiscount | undefined }))
    .filter((x) => !!x.deal)
    .sort((a, b) => (b.deal?.discountPct || 0) - (a.deal?.discountPct || 0));

  // Không shop nào có deal thật → ẩn section
  if (!shops.length) return null;

  return (
    <Layout
      iconName="time"
      title={locale === "en" ? t("home.slotDiscount") : title || t("home.slotDiscount")}
      description={rotatingDesc}
      className="bg-[#fff7ee]"
    >
      {/* Cuộn ngang toàn bộ shop có khung giờ khuyến mãi (không giới hạn số lượng) */}
      <Rail className="gap-4 px-4 md:px-6">
        {shops.map(({ shop, deal }) => (
          <ShopRowCard
            key={get(shop, "id")}
            shop={shop}
            variant="slot"
            deal={deal}
            className="w-[340px] md:w-auto md:min-w-[360px] md:flex-1 flex-shrink-0"
          />
        ))}
      </Rail>
    </Layout>
  );
};

export default SectionSlotDiscount;
